import { render, staticRenderFns } from "./BestCoinsAll.vue?vue&type=template&id=1dda98aa&scoped=true&"
import script from "./BestCoinsAll.vue?vue&type=script&lang=js&"
export * from "./BestCoinsAll.vue?vue&type=script&lang=js&"
import style0 from "./BestCoinsAll.vue?vue&type=style&index=0&id=1dda98aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda98aa",
  null
  
)

export default component.exports